module.exports = __webpack_public_path__ + "static/media/Archivo-Regular.72a7b5e8.ttf";